export default "__VITE_ASSET__CTm4SnCQ__"